import { css } from '@ringcentral/juno';

export const noSelectStyle = css`
  user-select: none;
  user-drag: none;
`;
